import React, { useContext, useEffect, useState } from 'react'
import PreApproveCaseModal from 'Modals/PreApproveCaseModal';
import PreapproveProfessionalsModal from 'Modals/PreapproveProfessionalsModal';
import { Context } from 'Context/Context';
import { casesStatusUpdateApi, getAllSubscribedProfessionals, preapprovedProfessionals, raiseNotificationApi } from 'Constants';
import { getCaseType } from 'Utils';
import PreApprovedProf from './PreApprovedProf';
import NoCases from 'Modals/NoCases';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import { toast, ToastContainer } from 'react-toastify';

function FindAttorney({caseList, updateCaseList, setUpdateCaseList}) {
  const [showModal, setShowModal] = useState(false);
  const {makeApiCallFunc, userDetails} = useContext(Context);
  const [findAttorneys, setFindAttorneys] = useState(false);
  const [caseInfo, setCaseInfo] = useState(null);
 useEffect(() => {
      setCaseInfo({
        _id: caseList?.[0]?._id,
        caseType: caseList?.[0]?.caseType,
        caseState: caseList?.[0]?.caseState
      });
    
  }, [caseList]);

  const [profList, setProfList] = useState([]);
  const [showNoCases, setShowNoCases] = useState(false);
  const navigate = useNavigate();

  const [showAttModal, setShowAttModal] = useState(false);
  const [availableProfessionals, setAvailableProfessionals] = useState(null);


  const approveProfessional = (profID) => {
    const postData = {
        caseId: caseInfo?._id,
        "userId" : profID,
        "assistantId" : null,
        caseStatus: "approved",
        isPreApproved: true
    }
    makeApiCallFunc(
        casesStatusUpdateApi,
        postData,
        (data) => {
            toast.success("Professional pre-approved successfully");
            seeAvailableProfessionals();
            
            const notificationObj = {
                title : "Pre-Approved Request - " + getCaseType(caseInfo?.caseType) + " - " + caseInfo?.caseNumber,
                is_read : false,
                sender: "client",
                notificationCategory: 1,
                caseNumber: caseInfo?.caseNumber,
                type: "3",
                receiver:  profID,
                additionalInfo: {
                    caseId: caseInfo?._id
                },
                content: "You have been pre-approved to view the case " + getCaseType(caseInfo?.caseType) + " - " + caseInfo?.caseNumber + " by the client. Find this case listed on the approved cases list. Now please make sure if there is any conflict."
            }
            makeApiCallFunc(raiseNotificationApi, 
                notificationObj, 
                (data) => console.log(data),
                (error) => console.log(error)
                )
        },
        (data) => {
            console.log(data)
        }
    )
    }
  const seeAvailableProfessionals = () => {
    setFindAttorneys(true);
    setAvailableProfessionals(null);
    makeApiCallFunc(
        getAllSubscribedProfessionals,
        {caseId: caseInfo?._id,
        casePref: caseInfo?.caseType,
        statePref: caseInfo?.caseState
        },
        ({data}) => {
          setFindAttorneys(false);
            setAvailableProfessionals(data?.available);
            setProfList(data?.approved);
            setShowAttModal(true);
        },
        (error) => {
            setFindAttorneys(false);
            console.log(error)
        }
    )
}

  // The modal design has no separate "Find An Attorney" trigger - matching
  // profiles load as soon as the modal is open (and refresh whenever the
  // selected case changes), instead of waiting for a manual button click.
  useEffect(() => {
    if (showModal && caseInfo?._id) {
      seeAvailableProfessionals();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showModal, caseInfo?._id]);

  return (
    <>
    {
        showModal &&
        <>
        <PreApproveCaseModal
        uploadNew={showModal}
        caseList={caseList}
        onClose={() => {setShowModal(false);setUpdateCaseList(!updateCaseList)}}
        onSubmit={() => seeAvailableProfessionals()}
        findAttorneys={findAttorneys}
        approveProfessional={approveProfessional}
        showAttModal={showAttModal}
        setShowAttModal={setShowAttModal}
        availableProfessionals={availableProfessionals}
        caseInfo={caseInfo}
        setCaseInfo={setCaseInfo}
        profList={profList}
        />
        </>
      }
      {
        showNoCases &&
        <NoCases
        uploadNew={showNoCases}
        onClose={() => setShowNoCases(false) }
        onSubmit= {() => {setShowNoCases(false); navigate("/client/createCase")}}
        />
      }
    <div
    className='w-full flex items-center justify-between gap-5 rounded font-plexsans flex-col lg:flex-row text-center lg:text-left p-5 lg:px-6 lg:py-5 mb-5'
    style={{background:'#fffdf8', border:'1px solid rgba(20,33,61,.14)', borderLeft:'2px solid #8a6231', borderRadius:'4px'}}
    >
        <div className='flex items-center gap-4 flex-col lg:flex-row'>
            <div className="flex-none rounded-full flex items-center justify-center" style={{width:'44px', height:'44px', background:'rgba(138,98,49,.1)'}}>
                <User className="w-[22px] h-[22px]" style={{color:'#8a6231'}} strokeWidth={1.6}/>
            </div>
            <div>
                <div style={{font:"400 15px/1.3 'Spectral',serif", color:'#14213d', marginBottom:'3px'}}>Find a law firm for your case</div>
                <div style={{font:"400 12px/1.5 'IBM Plex Sans',sans-serif", color:'rgba(20,33,61,.55)'}}>Review law firm profiles and pre-approve them to view your case details — before they ever request access.</div>
            </div>
        </div>
        <button 
        onClick={()=>{
          if(caseList)
          {
          if(caseList?.length > 0)
          {
            setShowModal(true)

          }
          else
          {
            setShowNoCases(true);
          }
        }
        }}
        className="flex-none whitespace-nowrap rounded-sm cursor-pointer transition-colors w-full lg:w-auto"
        style={{font:"500 12.5px/1 'IBM Plex Sans',sans-serif", color:'#fffdf8', background:'#8a6231', border:'none', padding:'12px 20px'}}
        onMouseEnter={(e) => e.currentTarget.style.background = '#6d4c25'}
        onMouseLeave={(e) => e.currentTarget.style.background = '#8a6231'}
        >
          Find a law firm
        </button>
    </div>
    </>
  )
}

export default FindAttorney